import React from "react";
import { FaHourglassHalf } from "react-icons/fa";
import "../../stylez/DayWorkedCard.css";

function CoachHoursCard({ coachName, hours = 0, eventCount = 0 }) {
  return (
    <div className="day-worked-card">
      <FaHourglassHalf className="hourglass-card-icon" />
      <div className="divider"></div>
      <div className="hours-content">
        <h3>{coachName}</h3>
        <p>
          {hours.toFixed(1)} hrs ({eventCount}{" "}
          {eventCount === 1 ? "class" : "classes"})
        </p>
      </div>
    </div>
  );
}

export default CoachHoursCard;
